import React, { useState } from "react";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) {
      setSubscribed(true);
      setEmail("");
      setTimeout(() => setSubscribed(false), 3000);
    }
  };

  return (
    <>
      <style jsx>{`
        footer {
          position: relative;
          background: linear-gradient(135deg, #0047ab 0%, #003087 100%);
          color: #ffffff;
          padding: 70px 0 20px;
          overflow: hidden;
        }

        footer::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100"><rect width="100" height="100" fill="none"/><circle cx="50" cy="50" r="40" stroke="rgba(255,255,255,0.03)" stroke-width="0.5" fill="none"/></svg>');
          background-size: 100px 100px;
          z-index: 0;
        }

        .footer-content {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
          gap: 40px;
          margin-bottom: 50px;
          position: relative;
          z-index: 1;
        }

        .footer-column h3 {
          font-size: 1.3rem;
          margin-bottom: 20px;
          color: #ffffff;
          position: relative;
          padding-bottom: 10px;
          display: flex;
          align-items: center;
        }

        .footer-column h3::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 40px;
          height: 2px;
          background: linear-gradient(90deg, #87CEEB, #ffffff);
        }

        .footer-column h3 .emoji {
          margin-right: 10px;
          font-size: 1.5rem;
        }

        .footer-column p {
          color: rgba(255, 255, 255, 0.8);
          line-height: 1.6;
          margin-bottom: 20px;
        }

        .footer-links {
          list-style: none;
          padding: 0;
        }

        .footer-links li {
          margin-bottom: 10px;
        }

        .footer-links a {
          color: rgba(255, 255, 255, 0.7);
          text-decoration: none;
          transition: all 0.3s ease;
          display: inline-block;
          position: relative;
        }

        .footer-links a::before {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 0;
          height: 1px;
          background: #87CEEB;
          transition: width 0.3s ease;
        }

        .footer-links a:hover {
          color: #87CEEB;
        }

        .footer-links a:hover::before {
          width: 100%;
        }

        .newsletter-form {
          display: flex;
          margin-top: 15px;
          border-radius: 50px;
          overflow: hidden;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(5px);
        }

        .newsletter-input {
          flex: 1;
          padding: 12px 15px;
          border: none;
          background: transparent;
          color: #ffffff;
          font-family: 'Inter', sans-serif;
        }

        .newsletter-input::placeholder {
          color: rgba(255, 255, 255, 0.7);
        }

        .newsletter-input:focus {
          outline: none;
        }

        .newsletter-button {
          padding: 12px 20px;
          background: linear-gradient(135deg, #87CEEB 0%, #4fc3f7 100%);
          color: #0047ab;
          border: none;
          font-family: 'Inter', sans-serif;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .newsletter-button:hover {
          background: linear-gradient(135deg, #4fc3f7 0%, #29b6f6 100%);
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(79, 195, 247, 0.3);
        }

        .social-links {
          display: flex;
          flex-wrap: wrap;
          gap: 15px;
          margin-top: 20px;
        }

        .social-links a {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 45px;
          height: 45px;
          background: rgba(255, 255, 255, 0.1);
          border-radius: 50%;
          color: #ffffff;
          transition: all 0.3s ease;
          position: relative;
          overflow: hidden;
        }

        .social-links a::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: radial-gradient(circle, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0) 70%);
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        .social-links a:hover::before {
          opacity: 1;
        }

        .social-links a svg {
          width: 20px;
          height: 20px;
          fill: currentColor;
          position: relative;
          z-index: 1;
        }

        .facebook:hover { 
          background-color: #1877f2; 
          transform: translateY(-3px);
          box-shadow: 0 5px 15px rgba(24, 119, 242, 0.3);
        }
        
        .linkedin:hover { 
          background-color: #0a66c2; 
          transform: translateY(-3px);
          box-shadow: 0 5px 15px rgba(10, 102, 194, 0.3);
        }
        
        .instagram:hover { 
          background: radial-gradient(circle at 30% 107%, #fdf497 0%, #fd5949 45%, #d6249f 60%, #285AEB 90%); 
          transform: translateY(-3px);
          box-shadow: 0 5px 15px rgba(214, 36, 159, 0.3);
        }
        
        .twitter:hover { 
          background-color: #1da1f2; 
          transform: translateY(-3px);
          box-shadow: 0 5px 15px rgba(29, 161, 242, 0.3);
        }
        
        .mail:hover { 
          background-color: #ea4335; 
          transform: translateY(-3px);
          box-shadow: 0 5px 15px rgba(234, 67, 53, 0.3);
        }

        .success-message {
          background: linear-gradient(135deg, rgba(79, 195, 247, 0.2) 0%, rgba(135, 206, 235, 0.2) 100%);
          color: #ffffff;
          padding: 15px;
          border-radius: 8px;
          margin-top: 20px;
          text-align: center;
          animation: fadeIn 0.5s ease;
          border: 1px solid rgba(255, 255, 255, 0.1);
        }

        .copyright {
          text-align: center;
          padding-top: 20px;
          border-top: 1px solid rgba(255, 255, 255, 0.1);
          font-size: 0.9rem;
          color: rgba(255, 255, 255, 0.7);
          position: relative;
          z-index: 1;
        }

        .footer-shapes {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 0;
          pointer-events: none;
          overflow: hidden;
        }

        .footer-shape {
          position: absolute;
          border-radius: 50%;
          background: linear-gradient(135deg, rgba(255,255,255,0.05) 0%, rgba(135,206,235,0.05) 100%);
          animation: float 20s infinite ease-in-out;
        }

        .footer-shape:nth-child(1) {
          width: 300px;
          height: 300px;
          top: -150px;
          right: -100px;
          animation-delay: 0s;
        }

        .footer-shape:nth-child(2) {
          width: 200px;
          height: 200px;
          bottom: -100px;
          left: -50px;
          animation-delay: 5s;
        }

        .footer-shape:nth-child(3) {
          width: 150px;
          height: 150px;
          top: 50%;
          left: -75px;
          animation-delay: 10s;
        }

        @keyframes float {
          0%, 100% { transform: translateY(0) rotate(0deg); }
          50% { transform: translateY(-20px) rotate(10deg); }
        }

        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @media (max-width: 768px) {
          footer {
            padding: 50px 0 20px;
          }
          
          .footer-content {
            grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
            gap: 30px;
          }
        }

        @media (max-width: 576px) {
          .footer-content { 
            grid-template-columns: 1fr; 
            gap: 25px;
          }
          
          .newsletter-form {
            flex-direction: column;
            border-radius: 8px;
          }
          
          .newsletter-button {
            border-radius: 0 0 8px 8px;
          }
        }
      `}</style>

      <footer>
        <div className="footer-shapes">
          <div className="footer-shape"></div>
          <div className="footer-shape"></div>
          <div className="footer-shape"></div>
        </div>
        
        <div className="container">
          <div className="footer-content">
            {/* Column 1: About + Social */}
            <div className="footer-column">
              <h3><span className="emoji">☀️</span> RAMA Reflection India Pvt Ltd</h3>
              <p>Leading the renewable energy revolution in India with innovative and sustainable solar solutions.</p>
              <div className="social-links">
                <a href="https://www.facebook.com/profile.php?id=61563334581871" className="facebook" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                  <svg viewBox="0 0 24 24"><path d="M22 12c0-5.522-4.477-10-10-10S2 6.478 2 12c0 5 3.657 9.127 8.438 9.878v-6.987h-2.54v-2.89h2.54V9.797c0-2.507 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.242 0-1.63.772-1.63 1.562v1.875h2.773l-.443 2.89h-2.33v6.987C18.343 21.127 22 17 22 12z" /></svg>
                </a>
                <a href="https://www.linkedin.com/company/103773397/" className="linkedin" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                  <svg viewBox="0 0 24 24"><path d="M4.98 3.5C4.98 4.88 3.87 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1 4.98 2.12 4.98 3.5zM0 8h5v16H0V8zm7.5 0h4.8v2.2h.1c.67-1.27 2.3-2.6 4.7-2.6 5 0 5.9 3.3 5.9 7.6V24h-5v-7.3c0-1.7-.03-3.9-2.38-3.9-2.4 0-2.77 1.88-2.77 3.8V24h-5V8z" /></svg>
                </a>
                <a href="https://www.instagram.com/ramareflection2010/" className="instagram" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                  <svg viewBox="0 0 24 24"><path d="M12 2.2c3.2 0 3.584.012 4.85.07 1.17.054 1.97.24 2.43.414.59.22 1.01.48 1.45.924.44.44.704.854.924 1.444.175.456.36 1.258.414 2.43.058 1.266.07 1.65.07 4.85s-.012 3.584-.07 4.85c-.054 1.17-.24 1.97-.414 2.43-.22.59-.48 1.01-.924 1.45-.44.44-.854.704-1.444.924-.456.175-1.258.36-2.43.414-1.266.058-1.65.07-4.85.07s-3.584-.012-4.85-.07c-1.17-.054-1.97-.24-2.43-.414-.59-.22-1.01-.48-1.45-.924-.44-.44-.704-.854-.924-1.444-.175-.456-.36-1.258-.414-2.43C2.212 15.584 2.2 15.2 2.2 12s.012-3.584.07-4.85c.054-1.17.24-1.97.414-2.43.22-.59.48-1.01.924-1.45.44-.44.854-.704 1.444-.924.456-.175 1.258-.36 2.43-.414C8.416 2.212 8.8 2.2 12 2.2zm0-2.2C8.736 0 8.332.012 7.053.07 5.774.128 4.782.312 4.03.594 3.234.883 2.587 1.293 1.95 1.93.583 3.297.128 5.026.07 7.053.012 8.332 0 8.736 0 12s.012 3.668.07 4.947c.058 2.027.513 3.756 1.88 5.123.637.637 1.284 1.047 2.08 1.336.752.282 1.744.466 3.023.524C8.332 23.988 8.736 24 12 24s3.668-.012 4.947-.07c2.027-.058 3.756-.513 5.123-1.88.637-.637 1.047-1.284 1.336-2.08.282-.752.466-1.744.524-3.023C23.988 15.668 24 15.264 24 12s-.012-3.668-.07-4.947c-.058-2.027-.513-3.756-1.88-5.123-.637-.637-1.284-1.047-2.08-1.336-.752-.282-1.744-.466-3.023-.524C15.668.012 15.264 0 12 0z" /><circle cx="12" cy="12" r="3.6" /></svg>
                </a>
                <a href="https://x.com/" className="twitter" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                  <svg viewBox="0 0 24 24"><path d="M24 4.557a9.83 9.83 0 01-2.828.775 4.932 4.932 0 002.165-2.724 9.864 9.864 0 01-3.127 1.195 4.918 4.918 0 00-8.384 4.482 13.957 13.957 0 01-10.141-5.15 4.918 4.918 0 001.523 6.574 4.903 4.903 0 01-2.229-.616c-.054 2.28 1.581 4.415 3.949 4.89a4.935 4.935 0 01-2.224.084 4.922 4.922 0 004.6 3.417A9.867 9.867 0 010 19.54 13.94 13.94 0 007.548 22c9.142 0 14.307-7.721 13.995-14.646A9.936 9.936 0 0024 4.557z" /></svg>
                </a>
                <a href="mailto:yashpalsar100@gmail.com" className="mail" aria-label="Email">
                  <svg viewBox="0 0 24 24">
                    <path d="M12 13.065L0 6V18h24V6l-12 7.065zm12-9.065H0l12 7 12-7z" />
                  </svg>
                </a>
              </div>
            </div>

            {/* Column 2: Quick Links */}
            <div className="footer-column">
              <h3><span className="emoji">🔗</span> Quick Links</h3>
              <ul className="footer-links">
                <li><a href="#home">Home</a></li>
                <li><a href="#about">About Us</a></li>
                <li><a href="#services">Services</a></li>
                <li><a href="#projects">Projects</a></li>
                <li><a href="#technology">Technology</a></li>
                <li><a href="#contact">Contact</a></li>
              </ul>
            </div>

            {/* Column 3: Services */}
            <div className="footer-column">
              <h3><span className="emoji">⚙️</span> Services</h3>
              <ul className="footer-links">
                <li><a href="#">Solar & BESS Turnkey EPC</a></li>
                <li><a href="#">Solar & BESS IPP Developers</a></li>
                <li><a href="#">PV Modules & Cells Manufacturers</a></li>
                <li><a href="#">Maintenance Services</a></li>
              </ul>
            </div>

            {/* Column 4: Newsletter */}
            <div className="footer-column">
              <h3><span className="emoji">✉️</span> Newsletter</h3>
              <p>Subscribe to our newsletter for the latest updates and insights on solar energy.</p>
              <form className="newsletter-form" onSubmit={handleSubscribe}>
                <input
                  type="email"
                  placeholder="Your email"
                  className="newsletter-input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  aria-label="Email for newsletter"
                />
                <button type="submit" className="newsletter-button">Done</button>
              </form>
              {subscribed && <div className="success-message">Thank you for subscribing! 🎉</div>}
            </div>
          </div>

         <div className="copyright">
  <p>
    &copy; 2019-25 RAMA Reflection India Pvt Ltd. All Rights Reserved. <span className="emoji">♻️</span> Powered by Solar Energy
  </p>
  
</div>

        </div>
      </footer>
    </>
  );
};

export default Footer;